export const staticRouter = [
  // 静态路由写法示例
  {
    path: '/test',
    name: 'test',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/systemManage/authorization/index.vue'),
    meta: {
      title: '测试静态路由'
    }
  }
];
